import gql from 'graphql-tag'

export default gql`
  query savedOrdersMobile($moduleName: String) {
    savedOrdersMobile(moduleName: $moduleName) {
      id
      Active
      OrderNo
      OrderType
      OrderTypeRaw: OrderType(raw: true)
      OrderTypeFull
      DateSaved
      DateShip
      Cases
      Bottles
      Total
      Po
      Coop
      Note
      ShipTo
      OrderDate
      Account {
        Po
        Bal
        Lic
        Rep
        Sup
        Wb1
        Wb2
        Wb3
        City
        Coop
        Days
        Last
        Prem
        Type
        Affil
        Focus
        Level
        State
        AcctNo
        County
        Growth
        Region
        Status
        Address
        DelNote
        AcctName
        AcctNote
        Wb1Email
        Wb1Phone
        Wb2Email
        Wb2Phone
        Wb3Email
        Wb3Phone
      }
      ShipTo
      Det {
        Price {
          value
          rawValue
          pricingTiers {
            tier
            price
          }
          product {
            Uom
            Code
            Brand
            Desc
            Vintage
          }
          mixedSizeItems {
            Code
            Brand
            Desc
            Vintage
          }
        }
        Uom
        Cases
        Bottles
        Code
        Description
        Mobo
        MoboQty {
          OrderNo
          OrderNoMobo
          Qty
          converted
        }
        maxItemQty {
          ActionPerOrderType
          byOrderType {
            id
            Qty
            Cases
            Bottles
          }
          PreviousAdd {
            Qty
            Cases
            Bottles
          }
        }
        Qty
        QtyA
      }
    }
  }
`
